import styled from 'styled-components';

export const FooterWapper = styled.div`
    display: flex;
    flex-direction: column;
`
export const StyledFooter = styled.div`
    background-color: #EAF1ED;
    color: #212529;
    padding-top: 36px;
    padding-bottom: 44px;
`

export const Copyright = styled.div`
    font-size: 13px;
    opacity: .5;
    text-align: right;
    font-weight: 300;

    a {
        color: #212529;
    }

    @media (max-width: 1000px) {
        text-align: center;
    }
`

export const FooterNavRow = styled.div`
    display: flex;
    justify-content: space-between;
    flex:1;

    @media (max-width: 1000px) {
        flex-direction: column;
    }
`

export const FooterNavCol = styled.div`

    & > div{
        padding: 4px 0;
    }

    h6{
        margin-bottom: 16px;
        color: #212529;
    }

    img {
        width: 180px;
    }

    a{
        color: #212529;
        text-decoration: none;
        font-size: 14px;
        opacity: .6;
    }

    @media (max-width: 1000px) {
        text-align: center;
        margin-bottom: 32px;
    }
`

export const StyledFooterInner = styled.div`
    display: flex;
    justify-content: space-between;
    flex:1;

    @media (max-width: 1000px) {
        flex-direction: column;
    }
`

export const SocialLinks = styled.div`
    display: flex;
    justify-content: end;
    gap: 16px;

    @media (max-width: 1000px) {
        justify-content: center;
    }
`

export const StyledFooterBottom = styled.div`
    text-align: right;

    @media (max-width: 1000px) {
        text-align: center;
        margin-top: 44px;
    }
`